import React, { memo } from 'react';
import { MicroserviceTypes } from 'typings';
import { UploadContent } from 'components/common';
import { ValidationErrors } from 'constants/validations';
import { Col, Form, FormModal, Row, Select, Upload } from 'components';
import { useAddEdit } from './useAddEdit';
import { AttachmentDataType } from '..';

const { Dragger } = Upload;

export interface IAddEditModal {
  modalState: boolean;
  entityName: string;
  dataToEdit?: AttachmentDataType;
  onModalStateChange: () => void;
  entityId: string;
  service?: MicroserviceTypes;
}

const ACCEPTED_FORMATS = ['text/csv', 'application/pdf', 'image/png', 'image/jpeg'];

export const AddEditModal = memo((props: IAddEditModal) => {
  const { modalState, entityName, entityId, dataToEdit, onModalStateChange, service } = props;
  const {
    contextHolder,
    form,
    handleSubmit,
    isLoading,
    attachmentType,
    isSaveBtnDisabled,
    handleFileSizeValidation,
    handleCancel,
  } = useAddEdit({
    onModalStateChange,
    entityName,
    modalState,
    dataToEdit,
    entityId,
    service,
  });

  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        width={400}
        title={`${dataToEdit ? 'Update' : 'Add'} Attachment`}
        okText={dataToEdit ? 'Save' : 'Add'}
        open={modalState}
        disableOkBtn={isSaveBtnDisabled}
        isLoading={isLoading}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
      >
        <Row gutter={[16, 16]}>
          {!dataToEdit && (
            <Col span={24}>
              <Form.Item
                name="attachment"
                label="Attachment*"
                rules={[
                  {
                    required: true,
                    validator: (_, value) => {
                      if (value && value.length > 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(ValidationErrors.required('File')));
                    },
                  },
                ]}
                getValueFromEvent={(e) => e?.fileList}
              >
                <Dragger
                  fileList={form.getFieldValue('attachment')}
                  beforeUpload={handleFileSizeValidation}
                  accept={ACCEPTED_FORMATS.join(',')}
                  maxCount={1}
                >
                  <UploadContent title={'Upload FIle'} message={'Max size: 5MB / Format: CSV, PDF, PNG, JPEG'} />
                </Dragger>
              </Form.Item>
            </Col>
          )}
          <Col span={24}>
            <Form.Item label={`Type`} name={'attachmentType'}>
              <Select size={'large'} options={attachmentType} />
            </Form.Item>
          </Col>
        </Row>
      </FormModal>
    </>
  );
});
